import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ViewDialogComponent } from '../../../../../core/components/viewDialog/viewDialogComponent';
import { ViewDialogInstance } from '../../../../../core/components/viewDialog/viewDialogService';
import { Task } from '../../../../shared/entities/task/task';
import { ControlTemplate } from '../../../form/entities/controlTemplate';

/**
 * Interface for the dialog data configuration
 */
interface FormViewDialogData {
  task: Task;
  template: ControlTemplate | null;
}

@Component({
  selector: 'app-form-view-dialog',
  template: `
    <app-form-view
      [index]="index"
      [controlTemplate]="controlTemplate">
    </app-form-view>
  `,
  styles: [`
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormViewDialogComponent implements ViewDialogInstance {
  // Injected services
  readonly ref = inject(DynamicDialogRef);
  readonly config = inject(DynamicDialogConfig<FormViewDialogData>);

  // Static data from dialog config
  readonly controlTemplate: ControlTemplate | null;
  readonly index: number | null;

  constructor() {
    // Extract data from config
    this.controlTemplate = this.config.data?.template ?? null;
    this.index = this.config.data?.index ?? 0;
    
  }

  onClose(viewDialogComponent: ViewDialogComponent<any>): void {
    // This method is called BEFORE the dialog is closed
    // Do cleanup here, but do NOT close the dialog - that's handled by ViewDialogComponent.close()
    console.log('Dialog wird geschlossen - führe Cleanup durch');
    // TODO: Add cleanup logic here if needed
  }

}
